import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IL_COLORS } from "../../../../constants/investmentLeague";

const BasePicksGrid = ({ picks = [] }) => {
  const theme = useTheme();
  const t     = theme.custom;

  if (!picks.length) {
    return (
      <Typography sx={{ fontSize: "13px", color: t.text3 }}>No base picks available.</Typography>
    );
  }

  return (
    <Box
      sx={{
        display:             "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(5, 1fr)",
        },
        gap: 1.5,
      }}
    >
      {picks.map((pick) => {
        const color = pick.positive ? IL_COLORS.positive : IL_COLORS.negative;
        const bg    = pick.positive ? IL_COLORS.positiveBg : IL_COLORS.negativeBg;

        return (
          <Box
            key={`${pick.label}-${pick.sub}`}
            sx={{
              position:     "relative",
              background:   bg,
              border:       `1px solid ${color}33`,
              borderRadius: "10px",
              p:            2,
              minHeight:    "100px",
            }}
          >
            <Box
              sx={{
                position:     "absolute",
                top:          10,
                right:        10,
                width:        8,
                height:       8,
                borderRadius: "50%",
                background:   color,
              }}
            />

            <Typography
              sx={{
                fontSize:   "13px",
                fontWeight: 700,
                color:      t.text,
                mb:         0.5,
              }}
            >
              {pick.label}
            </Typography>
            <Typography
              sx={{
                fontSize:   { xs: "18px", md: "20px" },
                fontWeight: 700,
                color,
                mb:         0.5,
              }}
            >
              {pick.value}
            </Typography>
            <Typography
              sx={{
                fontSize:      "10px",
                color:         t.text3,
                lineHeight:    1.4,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              {pick.sub}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default BasePicksGrid;
